var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 9.53562 15.558 11.0388 14.7269 12.33C13.8957 13.6213 12.7105 14.646 11.3127 15.2819C9.91494 15.9178 8.36369 16.1379 6.84418 15.9161C5.32468 15.6942 3.90113 15.0397 2.74352 14.0307C1.58592 13.0217 0.743165 11.7009 0.3159 10.2259C-0.111365 8.75091 -0.105089 7.18413 0.333978 5.71262C0.773046 4.24111 1.62635 2.92706 2.792 1.92737C3.95766 0.927688 5.3864 0.284611 6.90764 0.0749296L7.14796 1.81845C5.96139 1.982 4.84697 2.4836 3.93776 3.26335C3.02855 4.04311 2.36298 5.06807 2.0205 6.21584C1.67803 7.36362 1.67314 8.58571 2.0064 9.7362C2.33967 10.8867 2.99701 11.9169 3.89995 12.704C4.80288 13.491 5.91325 14.0015 7.09846 14.1745C8.28368 14.3476 9.49365 14.1759 10.5839 13.6799C11.6742 13.1839 12.5987 12.3846 13.247 11.3774C13.8953 10.3703 14.24 9.19778 14.24 8H16Z",
    fill: "#667799"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.e7af5e611f7c3de5a0f9f12f3e681203.svg";
export { ForwardRef as ReactComponent };